import { initializeApp } from "firebase/app";
import { getAuth, GoogleAuthProvider, FacebookAuthProvider } from "firebase/auth";
import { getFirestore } from "firebase/firestore";
import { getFunctions } from "firebase/functions";

export const firebaseConfig = {
 apiKey: "AIzaSyBZ9ypByzUi_2CfeRCghwH9mL3f9FLtWv0",
  authDomain: "being-happy-app.firebaseapp.com",
  projectId: "being-happy-app",
  storageBucket: "being-happy-app.firebasestorage.app",
  messagingSenderId: "501571360793",
  appId: "1:501571360793:web:0f51bf9dc35c6f5ae0b288",
  measurementId: "G-HNT8DVBLVN"
};

const app = initializeApp(firebaseConfig);
export const auth = getAuth(app);
export const db = getFirestore(app);

// Export functions client so AdminPanel can call the setUserRole callable function
export const functions = getFunctions(app);

// Providers exported for reuse
export const googleProvider = new GoogleAuthProvider();
export const facebookProvider = new FacebookAuthProvider();